<div class="loading" [style.display]="show ? 'block' : 'none'">
    <div class="loading-icon"></div>
</div>